import { render, staticRenderFns } from "./FlowChartView.vue?vue&type=template&id=3586b120&scoped=true"
import script from "./FlowChartView.vue?vue&type=script&lang=js"
export * from "./FlowChartView.vue?vue&type=script&lang=js"
import style0 from "./FlowChartView.vue?vue&type=style&index=0&id=3586b120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3586b120",
  null
  
)

export default component.exports